/**
 * Error state: something failed, and the user is told so.
 *
 * The correlation id is shown, not hidden. It is the same id written to the
 * client error report, so a support conversation can join the two. No internal
 * error message is rendered: the old server returned raw Mongo errors and
 * internal paths to the client roughly forty times.
 *
 * Audit references prevented here: server.js #9, calendar.jsx #12.
 *
 * @param {object} props
 * @param {string} props.title
 * @param {string} [props.description]
 * @param {string|null} [props.correlationId]
 * @param {(() => void)|null} [props.onRetry]
 * @param {string} [props.retryLabel]
 */
export function ErrorState({
  title,
  description,
  correlationId = null,
  onRetry = null,
  retryLabel = 'Try again',
}) {
  return (
    <div className="state-block state-block--error" role="alert">
      <p className="state-block__title">{title}</p>
      {description ? <p className="state-block__body">{description}</p> : null}
      {onRetry ? (
        <div className="state-block__action">
          <button type="button" className="btn" onClick={onRetry}>
            {retryLabel}
          </button>
        </div>
      ) : null}
      {correlationId ? (
        <p className="state-block__meta">
          Reference <span className="num">{correlationId}</span>
        </p>
      ) : null}
    </div>
  );
}
